module.exports = __webpack_public_path__ + "static/media/field names (somewhat edited).56d4ba40.xlsx";